import React from 'react';
import { companyInfo, images } from '../data/mockData';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-bg-page border-t border-border-light py-12">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <img 
              src={images.logo} 
              alt="VM Projekty & Stavby" 
              className="h-20 w-auto object-contain mb-4 logo-image"
            />
            <p className="body-small text-text-secondary">
              {companyInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="heading-6 mb-4">Kontakt</h4>
            <div className="space-y-2">
              <p className="body-small text-text-secondary">
                📧 {companyInfo.email}
              </p>
              <p className="body-small text-text-secondary">
                📞 {companyInfo.phone}
              </p>
              <p className="body-small text-text-secondary">
                📍 {companyInfo.address}
              </p>
              <p className="body-small text-text-secondary mt-4">
                IČO: {companyInfo.ico}
              </p>
              <p className="body-small text-text-secondary">
                DIČ: {companyInfo.dic}
              </p>
            </div>
          </div>

          <div>
            <h4 className="heading-6 mb-4">Navigace</h4>
            <div className="space-y-2">
              <button 
                onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })}
                className="block body-small text-text-secondary hover:text-brand-primary transition-colors"
              >
                Domů
              </button>
              <button 
                onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                className="block body-small text-text-secondary hover:text-brand-primary transition-colors"
              >
                Služby
              </button>
              <button 
                onClick={() => document.getElementById('why-us').scrollIntoView({ behavior: 'smooth' })}
                className="block body-small text-text-secondary hover:text-brand-primary transition-colors"
              >
                Proč my
              </button>
              <button 
                onClick={() => document.getElementById('references').scrollIntoView({ behavior: 'smooth' })}
                className="block body-small text-text-secondary hover:text-brand-primary transition-colors"
              >
                Reference
              </button>
              <button 
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                className="block body-small text-text-secondary hover:text-brand-primary transition-colors"
              >
                Kontakt
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-border-light pt-8 text-center">
          <p className="caption">
            © {currentYear} VM Projekty & Stavby. Všechna práva vyhrazena.
          </p>
        </div>
      </div>
    </footer>
  );
};
